import React, { useRef, useState } from "react";
import { Volume2, VolumeX, Play } from "lucide-react";

const POSTER = "/sofit-demo-poster.jpg";

export function VideoHero({ className = "" }) {
  const ref = useRef(null);
  const [muted, setMuted] = useState(true);
  const [paused, setPaused] = useState(false);

  const toggleSound = (e) => {
    e?.stopPropagation();
    const v = ref.current;
    if (!v) return;
    const next = !muted;
    v.muted = next;
    setMuted(next);
    if (!next) { v.play?.(); setPaused(false); }
  };

  const togglePlay = () => {
    const v = ref.current;
    if (!v) return;
    if (v.paused) { v.play(); setPaused(false); } else { v.pause(); setPaused(true); }
  };

  return (
    <div className={`relative h-72 lg:h-[440px] rounded-xl2 overflow-hidden bg-brand-soft animate-fade-up ${className}`} data-testid="welcome-demo-video">
      <video
        ref={ref}
        poster={POSTER}
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
        onClick={togglePlay}
        className="w-full h-full object-cover cursor-pointer"
      >
        <source src="/sofit-demo.webm" type="video/webm" />
        <source src="/sofit-demo.mp4" type="video/mp4" />
      </video>
      <div className="absolute inset-0 bg-gradient-to-t from-white/95 via-transparent to-black/10 pointer-events-none" />
      <div className="absolute top-4 left-4 inline-flex items-center gap-1.5 px-2.5 py-1 rounded-pill bg-brand text-white font-body font-bold text-[10px] tracking-widest pointer-events-none">
        <span className="w-1.5 h-1.5 rounded-full bg-white animate-live-pulse" />DEMO
      </div>
      <div className="absolute top-5 right-5 font-accent text-3xl text-brand text-right leading-tight -rotate-6 pointer-events-none">Stronger<br />Healthier<br />Happier<br />Together</div>
      {paused ? (
        <button onClick={togglePlay} aria-label="Play" className="absolute inset-0 m-auto w-16 h-16 rounded-full bg-white/90 flex items-center justify-center shadow-lg hover:scale-105 transition-transform" data-testid="demo-video-play">
          <Play size={26} className="text-ink ml-1" />
        </button>
      ) : null}
      <button
        onClick={toggleSound}
        aria-label={muted ? "Unmute" : "Mute"}
        data-testid="demo-video-sound"
        className="absolute bottom-4 right-4 w-11 h-11 rounded-full bg-ink/80 text-white flex items-center justify-center hover:bg-ink transition-colors backdrop-blur"
      >
        {muted ? <VolumeX size={18} /> : <Volume2 size={18} />}
      </button>
    </div>
  );
}
